module.exports = __webpack_public_path__ + "static/media/icon_19px_shopping-cart_blue.a1275323.svg";